"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubstitution = void 0;

/* eslint-disable id-length */
var resource = [{
  id: 'legacy-pill',
  v: 1,
  s: {
    id: 'conoce-tu-perfil-inversor',
    v: 2
  }
}];

var getSubstitution = function getSubstitution(id, version) {
  var substitution = resource.find(function (item) {
    return item.id === id && item.v === version;
  });
  return substitution ? {
    id: substitution.s.id,
    version: substitution.s.v
  } : null;
};

exports.getSubstitution = getSubstitution;